var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('img',{ref:"logo",attrs:{"src":"/assets/images/iconBlack.svg","alt":""}}),_c('div',{ref:"loaderText",staticClass:"loader_text"})])}
var staticRenderFns = []

export { render, staticRenderFns }